import * as actions from './actions'
import reducer from './reducer'
import * as selectors from './selectors'

export * from './models'

export const settings = { actions, reducer, selectors }

export default settings
